.time-picker-modal-header {
  line-height: 75px;
  text-align: center;
  margin-bottom: 30px;
  background-color: var(--main-text);
  color: #fff;
  font-size: 2.5em;
}

.time-picker-header-delivery {
  opacity: 0.5;
}

.picker-container {
  width: 260px;
  height: 260px;
  margin: 0 20px 20px;
  border-radius: 50%;
  background-color: #f0f0f0;
  position: relative;
}

.time-picker-modal-header .time-picker-header {
  cursor: pointer;
  opacity: 0.5;
}

.time-picker-modal-header .time-picker-header.active {
  cursor: default;
  opacity: 1;
}

.time-picker-modal-header .time-picker-header:hover {
  opacity: 1;
}

.ok-button {
  position: absolute;
  bottom: 0;
  right: 0;
}

.ok-button:hover {
  font-weight: 700;
  cursor: pointer;
}
